export default __webpack_public_path__ + "static/media/infra-16.4ba32fc1.webp";